<template>
  <base-card shadow no-padding class="tw-overflow-hidden tw-h-full sm:tw-h-auto">
    <div class="logo-wrapper tw-py-8 tw-flex tw-justify-center">
      <component :is="logo" class="tw-w-3/4 tw-max-h-32" />
    </div>
    <div class="tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6">
      <div class="tw-flex tw-justify-center tw-mt-2">
        <h4 class="tw-text-2xl tw-font-light">Sign In</h4>
      </div>
      <div class="tw-flex tw-justify-center tw-py-5 tw-text-red-600 tw-bg-red-200 tw-rounded-md tw-mt-2" v-if="errorMessage">
        {{ errorMessage }}
      </div>
      <base-form ref="form" v-model="isFormValid" class="tw-mt-8">
        <base-text-field label="Email" type="email" placeholder="Enter your email" v-model="email" @keyup.enter="submit" required />
        <base-text-field label="Password" type="password" placeholder="Enter your password" v-model="password" @keyup.enter="submit" required class="tw-mt-2" />
      </base-form>
      <div class="tw-flex tw-justify-end" v-if="showForgotPassword">
        <base-button type="text" @click="href('/signin/forgot')" size="sm">Forgot your password?</base-button>
      </div>
      <div class="tw-mt-10">
        <base-button class="tw-w-full" @click="submit()" :loading="anyLoading" size="lg" :disabled="!isFormValid">Sign In</base-button>
      </div>
      <div class="tw-text-sm tw-text-center tw-mt-5 tw-text-gray-600">
        <p>By continuing, you agree to Predictile's</p>
        <div class="tw-flex tw-justify-center">
          <base-button type="text" @click="goTo('https://www.predictile.com/member-terms-of-service/index.html')">Terms of Service</base-button>
          <span class="tw-mx-2">|</span>
          <base-button type="text" @click="goTo('https://www.predictile.com/privacy-policy/index.html')">Privacy Policy</base-button>
        </div>
      </div>
    </div>
  </base-card>
</template>

<script>
import PredictileLogo from "@/assets/images/predictile-logo-square.svg";
import RxHarmonyLogo from "@/assets/images/rx-harmony-logo.svg";
import cognito from "@/configuration/cognito";
import { mapGetters } from "vuex";
import { datadogRum } from "@datadog/browser-rum";

export default {
  components: {
    PredictileLogo,
    RxHarmonyLogo,
  },
  props: {
    initialEmail: String,
    buttonLocation: {
      type: String,
      default: "body",
    },
    showForgotPassword: {
      type: Boolean,
      default: true,
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    isLoading: Boolean,
  },
  data() {
    return {
      localIsLoading: false,
      isFormValid: true,
      email: null,
      password: null,
      newPassword: null,
      errorMessage: null,
    };
  },
  computed: {
    ...mapGetters("organization", ["cobrandId"]),
    ...mapGetters("cognito", ["id", "name"]),
    anyLoading() {
      return this.isLoading || this.localIsLoading;
    },
    logo() {
      switch (this.cobrandId) {
        case "rx-harmony":
          return "rx-harmony-logo";
      }
      return "predictile-logo";
    },
  },
  created() {
    this.email = this.initialEmail;
  },
  methods: {
    validate() {
      if (!this.$refs.form.checkValidity()) this.$refs.form.classList.add("was-validated");
    },
    submit() {
      if (!this.$refs.form.validate()) return;
      this.localIsLoading = true;

      // Add email to Datadog RUM session as an attribute
      if (datadogRum && this.email) {
        datadogRum.setUser({
          email: this.email,
        });
      }

      cognito.signIn({
        email: this.email ? this.email.trim().toLowerCase() : this.email,
        password: this.password,
        newPassword: this.newPassword,
        onComplete: () => (this.localIsLoading = false),
        onSuccess: () => {
          // Add id and name to Datadog RUM session as an attribute if successful sign in
          if (datadogRum && this.email) {
            datadogRum.setUser({
              email: this.email,
              id: this.id,
              name: this.name,
            });
          }
          this.$emit("success");
        },
        onFailure: (res) => (this.errorMessage = res.message),
      });
    },
    href(path) {
      this.$router.push(path);
    },
    goTo(path) {
      window.open(path, "_blank");
    },
  },
};
</script>

<style lang="scss">
.logo-wrapper {
  background-color: var(--logo-bg) !important;
}
</style>
